/* eslint-disable react/prop-types */
import React from 'react';
import classNames from 'classnames';
import { useIntl } from 'react-intl';
import styles from './styles';
import { makeStyles } from '@mui/styles';
import {
  Portlet,
  PortletContent,
  PortletFooter,
  PortletHeader,
} from 'components';
import { Button, TextField } from '@mui/material';
import PortletLabel from 'components/PortletLabel';
const useStyles = makeStyles(styles);

export default function AccountDetails(props) {
  const intl = useIntl();
  const classes = useStyles();
  const rootClassName = classNames(classes.root);
  const { setUpdateUser, user } = props;

  const handleOpen = () => {
    setUpdateUser(true);
  };

  return (
    <Portlet className={rootClassName}>
      <PortletHeader>
        <PortletLabel
          subtitle={intl.formatMessage({ id: 'app.myaccount.title' })}
          title={intl.formatMessage({ id: 'app.myaccount.subtitle' })}
          classes={classes}
        />
      </PortletHeader>
      <PortletContent noPadding={true}>
        <form noValidate={true} autoComplete="off">
          {/* Nombre y apellido */}
          <div className={classes.field}>
            <TextField
              className={classes.textField}
              helperText="Please specify the first name"
              label={intl.formatMessage({ id: 'app.myaccount.firstNameLabel' })}
              disabled={true}
              value={user.personal_info.firstname}
              variant="outlined"
              margin="dense"
              required={true}
            />
            <TextField
              className={classes.textField}
              helperText="Please specify the Last name"
              label={intl.formatMessage({ id: 'app.myaccount.lastNameLabel' })}
              disabled={true}
              value={user.personal_info.lastname}
              variant="outlined"
              margin="dense"
              required={true}
            />
          </div>
          {/* Correo electronico & Telefono */}
          <div className={classes.field}>
            <TextField
              className={classes.textField}
              label={intl.formatMessage({ id: 'app.myaccount.emailLabel' })}
              disabled={true}
              value={user.personal_info.email}
              variant="outlined"
              margin="dense"
              required={true}
            />
            <TextField
              className={classes.textField}
              label={intl.formatMessage({ id: 'app.myaccount.phoneNumbLabel' })}
              disabled={true}
              value={user.personal_info.tel}
              variant="outlined"
              margin="dense"
              required={true}
            />
          </div>
        </form>
      </PortletContent>
      <PortletFooter>
        <Button color="secondary" variant="outlined" onClick={handleOpen}>
          {intl.formatMessage({ id: 'app.myaccount.editProfileBtn' })}
        </Button>
      </PortletFooter>
    </Portlet>
  );
}
